<script lang="ts">
  import { Button } from "sveltestrap";
</script>

<div class="mainview text-center">
  <h3 style="font-weight:normal;">자세한 내용은 문의하기를 눌러주세요</h3>
  <div class="mt-4">
    <Button href="/contact" size="lg" color="dark" outline>문의하기</Button>
  </div>
</div>

<style lang="scss">
</style>
